import styled from 'styled-components';
import { smallMediaQuery } from '../../../../common/utilities/sizeHelpers';

interface ObsTemperatureProps {
    isLongForecastReading: boolean;
}
export const ObsTemperatureTextWrapper = styled.div`
    height: 100%;
    width: calc(100% - 83px);
`;

export const ObsTemperature = styled.div<ObsTemperatureProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 100%;
    font-size: ${({ isLongForecastReading }) => isLongForecastReading ? '71px' : '105px'};
    font-weight: 400;
    text-rendering: optimizeLegibility;
    color: #ffffff;

    @media ${smallMediaQuery} {
        font-size: 105px;
    }
`;
